import { FunctionComponent, useEffect, useState } from "react";
import * as React from "react";
import Button from "@mui/material/Button";
import Dialogs, { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import "../pages/Page.css";
import {
  FormHelperText,
  SxProps,
  TextField,
  Theme,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import "../App.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import IsLoading from "./isLoading";
import Autocomplete from "./Autocomplete";
import CancelIcon from "@mui/icons-material/Cancel";

// Dialog Component

type variant = "text" | "contained" | "outlined" | undefined;
type color =
  | "inherit"
  | "primary"
  | "secondary"
  | "success"
  | "error"
  | "info"
  | "warning"
  | undefined;
type size = "small" | "medium" | "large" | undefined;
interface DialogRoleProps {
  sx?: SxProps<Theme>;
  Buttondialog?: any;
  Dialogtitle?: any;
  Dialogcontenttext?: any;
  Buttonname?: any;
  variant?: variant;
  disabled?: boolean;
  url?: string;
  vertical?: string | number;
  horizontal?: string | number;
  onClick?: (ev: React.MouseEvent<HTMLButtonElement>) => void;
  color?: color;
  size?: size;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  style?: React.CSSProperties;
  getValues?: any;
  closeDio?: any;

  edit?: any;
  editzone?: any;
  editbay?: any;
  editservice?: any;

  placeholder?: string;
  textfield?: boolean;
  successMessage?: any;
  isLoading?: boolean;
  DialogtitleForSuccessMessage?: any;
}

const DialogRole: FunctionComponent<DialogRoleProps> = (props) => {
  const [open, setOpen] = React.useState(false);

  const { getValues, isLoading }: any = props;

  const initialValues: {
    Rolename: string;
    is_enabled: boolean;
  } = {
    Rolename: props.edit?.name || "",
    is_enabled: props.edit?.status ?? true,
  };

  const handleClickOpen = (scrollType: DialogProps["scroll"]) => () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [snackbarOpen, setSnackBarOpen] = React.useState(false);
  const [alertOpen, setAlertOpen] = useState(false);

  useEffect(() => {
    if (snackbarOpen) {
      setSnackBarOpen(false);
    }
  }, [snackbarOpen]);

  const descriptionElementRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    if (alertOpen) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement != null) {
        descriptionElement.focus();
      }
    }
  }, [alertOpen]);

  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const pageName = "Role";
  const valueit = sessionStorage.getItem("permission");
  const menuList: any = JSON.parse(
    valueit === null
      ? localStorage.getItem("permission") || "null"
      : sessionStorage.getItem("permission") || "null"
  );
  const test_val = menuList
    .map((data: any) => {
      return data.sub_menus.filter((child: any) => {
        return child.name === pageName;
      });
    })
    .filter((final: any) => {
      return final.length > 0;
    })
    .reduce((retus: any, currentarray: any) => {
      return currentarray;
    }, {});

  const MenuOfUserpermission = test_val[0];

  return (
    <>
      <Button
        disabled={MenuOfUserpermission?.permission?.add === false}
        onClick={handleClickOpen("paper")}
        color={props.color}
        size={props.size}
        startIcon
        variant={props.variant}
        endIcon
        sx={props.sx}
      >
        {props.Buttonname}
      </Button>

      <Dialogs
        open={open}
        fullScreen={fullScreen}
        PaperProps={{
          sx: {
            borderRadius: "5px",

            "&::-webkit-scrollbar": { display: "none" },
          },
        }}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle
          id="scroll-dialog-title"
          style={{
            backgroundColor: "green",
            color: "white",
            fontFamily: "Roboto",
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "space-between",
          }}
        >
          {props.Dialogtitle}
          <CancelIcon
            sx={{ color: "white", cursor: "pointer" }}
            onClick={handleClose}
          ></CancelIcon>
        </DialogTitle>
        <DialogContent dividers={true} style={{ minWidth: "200px" }}>
          <Formik
            initialValues={initialValues}
            validationSchema={Yup.object().shape({
              Rolename: Yup.string().required("Please enter a name"),
              is_enabled: Yup.boolean().required("Please select the status"),
            })}
            onSubmit={(values) => {
              getValues(values);
              handleClose();
              setAlertOpen(true);
            }}
          >
            {(props) => {
              return (
                <Form id="form" autoComplete="off">
                  <IsLoading isLoading={isLoading} />
                  <div style={{ height: "110px", width: "25rem" }}>
                    <div
                      style={{
                        fontSize: "15px",
                        color: "#000000",
                        fontFamily: "Roboto",
                        paddingBottom: "7px",
                      }}
                    >
                      Name <span style={{ color: "red" }}>*</span>
                    </div>

                    <TextField
                      id="outlined-basic"
                      variant="outlined"
                      name="Rolename"
                      sx={{
                        "& fieldset": {
                          borderRadius: "5px",
                        },
                      }}
                      autoComplete="off"
                      error={
                        !!(props.errors.Rolename && props.touched.Rolename)
                      }
                      onChange={(e: any) => {
                        const inputValue = e.target.value;
                        // Use regex to check if the input contains only characters (letters)
                        if (
                          /^[A-Za-z0-9\s]+$/.test(inputValue) &&
                          inputValue.length < 31
                        ) {
                          props.setFieldValue("Rolename", inputValue);
                        } else {
                          // If validation fails, remove the last character from the input value
                          props.setFieldValue(
                            "Rolename",
                            inputValue.slice(0, -1)
                          );
                        }
                      }}
                      onBlur={props.handleBlur}
                      value={props.values.Rolename}
                      style={{
                        width: "100%",
                        height: "50px",
                        margin: "0px 0px 0px",
                      }}
                    />
                    {props.errors.Rolename && props.touched.Rolename ? (
                      <FormHelperText
                        style={{ marginLeft: "13px", marginTop: "10px" }}
                        error
                      >
                        {"Please enter a name"}
                      </FormHelperText>
                    ) : null}
                  </div>
                  <div style={{ height: "110px", width: "25rem" }}>
                    <div
                      style={{
                        color: "#000000",
                        paddingBottom: "5px",
                        fontSize: "15px",
                        fontFamily: "Roboto",
                      }}
                    >
                      Status <span style={{ color: "red" }}>*</span>
                    </div>

                    <Autocomplete
                      Listitem={[
                        { label: "Active", value: true },
                        { label: "InActive", value: false },
                      ]}
                      variant={"outlined"}
                      name={"is_enabled"}
                      value={props.values}
                      onBlur={props.handleBlur}
                      onchange={(e: any) => {
                        props.setFieldValue("is_enabled", e.value);
                      }}
                      style={{
                        paddingBottom: "27px",
                        width: "100%",
                        height: "50px",
                        borderBottom: "50px",
                      }}
                      error={
                        props.errors.is_enabled && props.touched.is_enabled
                      }
                    ></Autocomplete>
                    {props.errors.is_enabled && props.touched.is_enabled ? (
                      <FormHelperText
                        style={{ marginLeft: "13px", marginTop: "10px" }}
                        error
                      >
                        {"Please select a status"}
                      </FormHelperText>
                    ) : null}
                  </div>

                  <DialogActions
                    style={{
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      onClick={handleClose}
                      style={{
                        width: "100px",
                        height: "40px",
                        border: "1px solid #EF990F",
                        color: "black",
                        marginRight: "1%",
                        backgroundColor: "white",
                        borderRadius: "5px",
                        fontFamily: "Roboto",
                        fontSize: "16px",
                        textTransform: "capitalize",
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      style={{
                        width: "100px",
                        height: "40px",
                        color: "black",
                        background: !props.isValid
                          ? "linear-gradient(to right, #FFFA02,#F2A618 )"
                          : "linear-gradient(to right, #FFFA02,#F2A618 )",

                        borderRadius: "5px",
                        fontFamily: "Roboto",
                        fontSize: "16px",
                        textTransform: "capitalize",
                      }}
                    >
                      Save
                    </Button>
                  </DialogActions>
                </Form>
              );
            }}
          </Formik>
        </DialogContent>
      </Dialogs>
    </>
  );
};

export default DialogRole;
